<template>
  <v-card class="mx-auto elevation-0 mt-10 pa-8 mb-5" max-width="850px">
    <h2 class="text-h5 mb-2 font-weight-regular text-center">
      {{ $t("CreateyourAccount") }}
    </h2>
    <div class="mb-2 text-center">
      {{ $t("Alreadyamember") }}
      <router-link
        class="text-decoration-none"
        :to="{ name: 'Login', query: { redirect: $route.query.redirect } }"
      >
        {{ $t("LoginNow") }}
      </router-link>
    </div>
    <v-card-text class="pt-4 pb-4">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
      >
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              type="text"
              outlined
              v-model="data.fname"
              :rules="reqRules"
              v-bind:label="$t('FirstName')"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              type="text"
              v-model="data.lname"
              v-bind:label="$t('LastName')"
              :rules="reqRules"
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              type="email"
              v-model="data.email"
              v-bind:label="$t('EmailAddress')"
              :rules="emailRules"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <vue-tel-input-vuetify
              outlined
              v-bind:label="$t('PhoneNumber')"
              :rules="phoneRules"
              v-model="data.phone"
              aria-autocomplete=""
              placeholder=""
              mode="international"
              defaultCountry="US"
              :preferredCountries="['US', 'JP']"
              hide-details="auto"
            ></vue-tel-input-vuetify>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              type="Password"
              v-model="data.password"
              v-bind:label="$t('Password')"
              :rules="reqRules"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              type="Password"
              v-model="data.cpassword"
              v-bind:label="$t('ConfirmPassword')"
              :rules="confirmPasswordRules"
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-bind:label="$t('Addressline1')"
              :rules="reqRules"
              v-model="data.address"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-bind:label="$t('Addressline2')"
              v-model="data.address2"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-bind:label="$t('City')"
              :rules="reqRules"
              v-model="data.city"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-bind:label="$t('Statesprovinces')"
              :rules="reqRules"
              v-model="data.state"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-bind:label="$t('ZIPPostalcode')"
              :rules="reqRules"
              type="number"
              v-model="data.postalcode"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              :items="countries"
              item-text="country"
              item-value="country"
              v-bind:label="$t('Country')"
              v-model="data.country"
              :rules="reqRules"
              hide-details="auto"
              outlined
              @change="handlePrimaryCountry()"
            ></v-select>
            <div class="mt-3" v-if="data.country">
              <v-checkbox
                class="mt-0"
                v-model="primary_country_check"
                v-bind:label="$t('CountryMsg1')"
                @change="handlePrimaryCountry()"
              ></v-checkbox>
              <div v-if="primary_country_check">
                <div class="mb-4">{{ $t("CountryMsg2") }}</div>
                <v-select
                  :items="countries"
                  item-text="country"
                  item-value="country"
                  v-bind:label="$t('PrimaryCountry')"
                  v-model="data.primary_country"
                  :rules="reqRules"
                  hide-details="auto"
                  outlined
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-avatar v-if="!data.profilePic" color="light-blue" size="62">
              <span class="white--text text-h5">NR</span>
            </v-avatar>
            <v-avatar v-if="data.profilePic" size="62">
              <img :src="$store.state.baseUrl + data.profilePic" />
            </v-avatar>
            <v-dialog fullscreen v-model="dialog" width="50%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text color="grey" v-bind="attrs" v-on="on">
                  {{ $t("Pickanavatar") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline light-blue darken-4 white--text">
                  {{ $t("Pickanavatar") }}
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red darken-1"
                    dark
                    x-small
                    fab
                    @click="dialog = false"
                  >
                    <v-icon>mdi-window-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="pa-9">
                  <v-radio-group v-model="data.profilePic" row>
                    <v-radio
                      width="20%"
                      class="pa-5"
                      v-for="n in 115"
                      :key="n"
                      :value="'avatar/' + n + '.png'"
                      @change="dialog = false"
                    >
                      <template v-slot:label>
                        <v-avatar size="62">
                          <img
                            :src="$store.state.baseUrl + 'avatar/' + n + '.png'"
                          />
                        </v-avatar>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-input
              v-model="data.profilePic"
              hidden
              :rules="[v => !!v || $t('string735')]"
            ></v-input>
          </v-col>
          <v-col cols="12" md="8">
            <div class="subtitle-2 mb-4">{{ $t("Cmsg6") }}</div>
            <v-text-field
              v-bind:label="$t('AirBnBusername')"
              v-model="data.airbnbId"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox v-model="data.terms" :rules="reqRules">
              <template v-slot:label>
                <a
                  target="_blank"
                  href="https://member.nomadrooms.com/terms/general-terms/"
                  @click.stop
                >
                  {{ $t("Iagreetothetermsandconditions") }}
                </a>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn
              large
              color="light-blue"
              rounded
              dark
              type="submit"
              min-width="400px"
            >
              <span class="mr-2">{{ $t("Register") }}</span>
              <v-icon size="small">mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-card-text>
  </v-card>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import AuthService from "@/services/AuthService";
import Countries from "@/assets/countries.json";

export default {
  name: "RegisterComponent",
  components: { WaitDialogComponent },
  props: ["data"],
  data() {
    return {
      primary_country_check: false,
      waitDialog: false,
      dialog: false,
      valid: null,
      error: null,
      countries: Countries,
      reqRules: [value => !!value || this.$t("string719")],
      emailRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^(([^<>()[\]\\.,;:+\s@"]+(\.[^<>()[\]\\.,;:+\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("string724");
        }
      ],
      phoneRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /[A-Za-z]+/;
          return !pattern.test(value) || this.$t("string722");
        },
        value =>
          (value.length >= 7 && value.length <= 18) || this.$t("string723")
      ],
      confirmPasswordRules: [
        value => !!value || this.$t("string719"),
        value => {
          return this.data.password === value || this.$t("string725");
        }
      ]
    };
  },
  methods: {
    handlePrimaryCountry() {
      if (!this.primary_country_check) {
        this.data.primary_country = this.data.country;
      } else {
        this.data.primary_country = "";
      }
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await AuthService.register(this.data)
          .then(result => {
            this.waitDialog = false;
            this.data.user_id = result.data.uid;
            this.$router.push({
              name: "EmailVerification",
              params: { id: this.data.user_id },
              query: { redirect: this.$route.query.redirect }
            });
          })
          .catch(err => {
            this.waitDialog = false;
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style>
.country-code .v-text-field__details {
  display: none;
}
.country-code .v-input__slot {
  margin: 0;
}
.vue-tel-input-vuetify .country-code {
  align-self: baseline;
}
</style>
